import { TableColumn } from "../../../../components/ModularDataTable/types"
import { i18n } from "../../../../translate/i18n"
import { Input } from "../../../../components/Input/Input";
import { AggregatorClassification, PageOptions } from "../aggregadorCategory.type";
import SVG from 'react-inlinesvg'

export const createColumns = ({ switchStatus }: any): TableColumn[] => {
    const columns: TableColumn[] = [
        {
            key: 'Icone',
            value: 'name',
            type: 'custom',
            sortable: false,
            render: (_value: any, row: AggregatorClassification) => (
                <SVG
                    src={row.icon.svg}
                    style={{
                        width: '45px',
                        height: '45px',
                    }}
                />
            ),
        },
        { key: i18n.t(`aggregador_classification.table.name`), value: 'name', type: 'text' },
        {
            key: i18n.t(`aggregador_classification.table.segment`),
            value: 'segment',
            type: 'custom',
            sortable: false,
            render: (_value: any, row: AggregatorClassification) => (
                <span>{row.pluginspaceSegment.segmentParent.name}</span>
            ),
        },
        {
            key: 'Status',
            value: 'status',
            type: 'custom',
            align: 'center',
            render: (_value: any, row: AggregatorClassification) => (
                <div className='mt-5'>
                    <Input
                        value={row.status}
                        checked={row.status}
                        change={(val: boolean) => {
                            switchStatus({ endpoint: 'product', Id: row.id, status: val })
                        }}
                        inputAttr={{ type: 'checkbox' }}
                        checkSwift={true}
                    />
                </div>
            ),
        },
        {
            key: i18n.t(`smart_order.created`),
            value: 'created',
            type: 'datetime',
            sortable: true,
            visible: false
        },
        {
            key: i18n.t(`smart_order.updated`),
            value: 'updated',
            type: 'datetime',
            sortable: true,
            visible: false
        }

    ]

    return columns
}


export const createColumnsSubCategory = ({ switchStatus }: any): TableColumn[] => {
    const columns: TableColumn[] = [
        {
            key: 'Icone',
            value: 'name',
            type: 'custom',
            render: (_value: any, row: AggregatorClassification) => (
                <SVG
                    src={row.icon.svg}
                    style={{
                        width: '45px',
                        height: '45px',
                    }}
                />
            ),
        },
        { key: i18n.t(`aggregador_classification.table.name`), value: 'name', type: 'text' },
        {
            key: i18n.t(`aggregador_classification.table.type`), value: 'type', type: 'custom',

            render: (_value: any, row: AggregatorClassification) => (
                <span>{PageOptions.find(option => option.value === row.type)?.select}</span>
            ),
        },
        {
            key: i18n.t(`aggregador_classification.table.classification`),
            value: 'classification',
            type: 'custom',

            render: (_value: any, row: AggregatorClassification) => (
                <span>{row.parent.name}</span>
            ),
        },

        {
            key: 'Status',
            value: 'status',
            type: 'custom',
            align: 'center',
            render: (_value: any, row: AggregatorClassification) => (
                <div className='mt-5'>
                    <Input
                        value={row.status}
                        checked={row.status}
                        change={(val: boolean) => {
                            switchStatus({ endpoint: 'product', Id: row.id, status: val })
                        }}
                        inputAttr={{ type: 'checkbox' }}
                        checkSwift={true}
                    />
                </div>
            ),
        },
        {
            key: i18n.t(`smart_order.created`),
            value: 'created',
            type: 'datetime',
            sortable: true,
            visible: false
        },
        {
            key: i18n.t(`smart_order.updated`),
            value: 'updated',
            type: 'datetime',
            sortable: true,
            visible: false
        }

    ]

    return columns
}